<template>
  <div class="index container">
    <transition name="fade">
      <router-view @showParent="showParent"> </router-view>
    </transition>

    <div v-if="showParentPage">
      <v-breadcrumbs>
        <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
          >Home</v-breadcrumbs-item
        >
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item
          :exact="true"
          :to="{ name: 'module', params: {} }"
          active
        >
          Module
        </v-breadcrumbs-item>
      </v-breadcrumbs>

      <div class="d-flex flex-column flex-lg-row">
        <v-text-field
          dense
          v-model="search"
          prepend-icon="mdi-magnify"
          outlined
          label="Search"
        />
        <v-btn
          class="ml-0 ml-lg-4 mb-2 mb-lg-0 align-self-end align-self-lg-start"
          color="primary"
          :to="{ name: 'moduleCreate', params: {} }"
        >
          Create Module
        </v-btn>
      </div>

      <div class="table-container">
        <v-data-table
          :headers="headers"
          :items="moduleList"
          :items-per-page="pagination.pageSize"
          :loading="isAppLoading"
          :server-items-length="pagination.totalSize"
          :page="pagination.current"
          :disable-sort="true"
          item-key="id"
          class="elevation-1"
          @pagination="pageChanged"
        >
          <template v-slot:item.active="{ item }">
            <a @click="edit(item)">{{ item.active ? "Active":"Disabled" }}</a>
          </template>

          <template v-slot:item.logo_image="{ item }">
            <a @click="view(item)">{{ item.logo_image }}</a>
          </template>

          <template v-slot:item.path="{ item }">
            <a @click="view(item)">{{ item.path }}</a>
          </template>

          <template v-slot:item.icon="{ item }">
            <a @click="view(item)">{{ item.icon }}</a>
          </template>

          <template v-slot:item.color="{ item }">
            <a @click="view(item)">{{ item.color }}</a>
          </template>

          <template v-slot:item.description="{ item }">
            <a @click="view(item)">{{ item.description }}</a>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="edit(item)"> mdi-pencil </v-icon>
            <v-icon small class="mr-2" @click="remove(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </div>
    </div>
    <confirmation-dialog ref="confirm" />
  </div>
</template>

    <script>
import { mapActions, mapGetters } from "vuex";
const ConfirmationDialog = () =>
  import("@/components/common/ConfirmationDialog.vue");
import { getAccountModules } from '@/services/module'

export default {
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 100,
      },
      moduleList: [],
      showParentPage: true,

      headers: [
        {
          text: "Active",
          value: "active",
          align: "start",
          sortable: true,
        },
        {
          text: "Name",
          value: "name",
          align: "start",
          sortable: true,
        },
        {
          text: "Logo Image",
          value: "logo_image",
          align: "start",
          sortable: false,
        },
        {
          text: "undefined",
          value: "path",
          align: "start",
          sortable: false,
        },
        {
          text: "Icon",
          value: "icon",
          align: "start",
          sortable: false,
        },
        {
          text: "color",
          value: "color",
          align: "start",
          sortable: false,
        },
        {
          text: "Description",
          value: "description",
          align: "start",
          sortable: false,
        },

        { text: "Actions", value: "actions", align: "end", sortable: false },
      ],
      sort: {
        key: null,
      },
      search: "",
      myAccountModules: []
    };
  },
  components: {
    ConfirmationDialog,
  },
  computed: {
    ...mapGetters("module", ["moduleProcessed", "getModules"]),
    ...mapGetters("navigation", ["isAppLoading"]),
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
    ]),
    ...mapActions("module", ["deleteModule", "fetchModules"]),
    view(item) {
      this.$router.push({ name: "moduleView", params: { id: item.id } });
    },
    edit(item) {
      this.$router.push({ name: "moduleEdit", params: { id: item.id } });
    },
    async remove(item) {
      let confirm = await this.$refs.confirm.open(
        "Confirm Delete",
        "Do you want to delete this module?"
      );
      if (confirm) {
        this.deleteModule(item.id)
          .then(() => {
            this.addSuccessMessage("module was deleted with successfull!");
            this.getResources();
          })
          .catch(() => {
            this.addErrorMessage("Server response with error ");
          });
      }
    },
    getResources(searchTerms) {
      const params = {
        pageIndex: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
        query: searchTerms,
        sort: 'name'
      };
      this.fetchModules(params)
        .then((response) => {
          if (response) {
            this.pagination.totalSize = response.totalElements;
            this.moduleList = response.content;

            this.moduleList.forEach(m => {
              const active = this.myAccountModules.find( myM => myM.id == m.id);
              if(active){
                m.active = true;
              }
            })
          }
        })
        .catch((error) => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    showParent(show) {
      this.showParentPage = show;
    },
    pageChanged(pagination) {
      this.pagination.pageIndex = pagination.page;
      this.pagination.pageSize = pagination.itemsPerPage;

      this.getResources();
    },
    async fetchAccountModules() {
      console.log("fetching account modules");
      return await getAccountModules().then( (resp) => {
        return resp.data.content;
      })
    },
  },
  watch: {
    "pagination.numberRegisterForPage": function () {
      this.pagination.current = -1;
    },
    search: function (query) {
      if (!query) {
        return;
      }

      if (this.isAppLoading) return;

      this.getResources(query);
    },
  },
  created() {
    this.fetchAccountModules()
      .then( (accountModules ) => {
        this.myAccountModules = accountModules;
        this.getResources();
      })
  },
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split("/").length;
    const fromDepth = from.path.split("/").length;
    this.showParentPage = toDepth < fromDepth;
    if (this.showParentPage) {
      this.getResources();
    }
    next();
  },
};
</script>

    